<div class="schedule-reminder--bordered d-flex flex-row align-items-center pt-1 pl-3 pb-2 mb-3">
    <div class="d-block pl-2 mr-4" style="width: 3rem;">
        <div class="subtitle-2 d-flex justify-content-center" style="color: red; text-transform: uppercase;">
            {{month}}
        </div>
        <div class="headline-4 d-flex justify-content-center" style="color: #000000;">
            {{day}}
        </div>
        <div class="body-2 d-flex justify-content-center" style="color: #626262;">
            {{year}}
        </div>
    </div>
    <div style="border-left: 1px solid rgba(230,230,230, 1); height: 86px;"></div>

    <div class="d-flex flex-column ml-4">

        <div class="d-flex align-items-center upcoming-scheduler-task-type grey-text mb-1">
            <div [ngStyle]="{ 'background-color': reminderTypeColor }" class="upcoming-scheduler-task-type__sign mr-1"></div>
            <span>{{reminderTypeText}}</span>
        </div>
        <div class="body-1 mb-2">
            {{campaignName}}
        </div>
        <div class="d-flex">
            <div class="d-flex align-items-center body-2 mr-3">
                <i class="fas fa-clock mr-2"></i>
                <span>{{scheduledTime}}</span>
            </div>
        </div>
    </div>

    <button (click)="cancelReminder()" href="#" class="btn btn--paybee button btn-solid-border btn--padding10x15 btn--scheduler-cancel ml-auto mr-4">
        Cancel
    </button>
</div>